import productApis from './product/index';
import { init, getDomain } from 'sky-domain';

init('sso', process.env.NODE_ENV);

const iglobalwinHostConfig = {
	development: '//dev-api.iglobalwin.com',
	production: '//api.iglobalwin.com',
	testing: '//test-api.iglobalwin.com',
	preProduction: '//pre-api.iglobalwin.com',
};

const hostConfig = {
	iglobalwinHost: iglobalwinHostConfig[process.env.NODE_ENV],
	ssoHost: getDomain('sso').api,
	messageHost: getDomain('message').api,
	oaHost: getDomain('oa').api,
};

const apis = productApis(hostConfig);
export default apis;

// let {
//   project
// } = hostConfig

// let apis = devApis

// if (process.env.NODE_ENV == 'production') {
//   apis = productApis
// } else {
//   if (process.env.useProdAPI) {
//     apis = productApis
//   } else {
//     apis = devApis
//   }
// }
// let baseUrl = `//${project}`; //process.env.VUE_APP_DOMAIN || ''

// let needBaseUrl = url => {
//   return !(
//     url.startsWith('//') ||
//     url.startsWith('http') ||
//     url.startsWith('https')
//   )
// }

// function foreachApis(api) {
//   _.forEach(api, function (value, key) {
//     if (typeof value == 'object') {
//       foreachApis(value)
//     } else {
//       api[key] = needBaseUrl(value) ? baseUrl + value : value
//     }
//   })
// }

// foreachApis(apis)
// export default apis
